<template lang="pug">
.content.flex.flex-wrap
  ul.col-4.px1.classify-list.list-reset.flex.flex-column(v-for="column, colIdx in data")
    li.classify-item.pt2(v-for="columnItem, rowIdx in column")
      .top
         router-link(:to="keys[colIdx][rowIdx] === 0? {path: '/'}: {path: '/', query: {id: keys[colIdx][rowIdx]}}") {{ cidsObj[keys[colIdx][rowIdx]] }}
      ul.primary-list.list-reset.mt1.mb0.flex.flex-column
        li(v-for="item, idx in columnItem", :key="item.id", :class="idx === 0? 'border-bottom': null")
          .primary-img.col-12.relative(v-if="idx === 0", data-ratio="16/9")
            a(:href="item.origin_url", target="_blank")
              img.fit(:src="shift(item.o_pic_list[0])")
          .primary-info.py1
            a(:href="item.origin_url", target="_blank")
              .item-title(:title="item.title", :data-clamp="idx ===0? 3: 2") {{ item.title }}
            .sub.col-12
              | {{ item.pub_source }}
              span.px1 |
              | {{ formatUtc(item.pub_utc) }}
</template>

<script>
import moment from 'moment'
import _forEach from 'lodash/forEach'
import cids from '@/assets/cids'

import transformImgLink from '@/assets/utils/transformImgLink'
export default {
  props: ['data', 'keys', 'cids'],
  methods: {
    shift (link) {
      return transformImgLink(link)
    },
    formatUtc (utc) {
      return moment.unix(utc).format('DD-MM-YYYY HH:mm')
    }
  },
  computed: {
    cidsObj () {
      let cidsObj = {}
      _forEach(cids, val => {
        cidsObj[val['cid']] = val['label']
      })
      return cidsObj
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../assets/variables.styl';
.classify-list
  border-color $color-border
  &:not(:nth-child(3n))
    border-right 1px solid $color-border
  &:nth-child(3n-2)
    padding-left 0
  .top
    border-bottom 1px solid $color-primary
    margin-bottom 20px
    a
      display inline-block
      height 26px
      line-height 26px
      border-radius 14px 0 14px 0
      background $color-primary url(../../static/hot.png) 10px center no-repeat
      background-size 12px 14px
      color white
      padding 2px 20px 2px 40px
  .primary-list
    li
      border-color $color-border
      &:nth-child(n+3)
        margin-top 8px
      .primary-img
        overflow hidden
      .primary-img
        img
          width 100%
          transform scale(1.3)
          transition-duration 1s
          transition transform .3s ease-out
        &:hover
          img
            transform scale(1.5)
            transition-duration .8
</style>



// WEBPACK FOOTER //
// ClassifyList.vue?30dab072